export var convertTokensParamToArray = function (tokens) {
    const params = {};
    for (const param of tokens.split('&')) {
        const [key, value] = param.split('=');
        if (key.substring(0, 6) === 'tokens') {
            if (key.includes('[')) {
                const subKey = key.split('[')[1].split(']')[0];
                params[subKey] = value;
            } else {
                params[key] = value;
            }
        }
    }
    return params;
}
